import defaultRouting from '../config/flypay-return.js'

function approvedOrigin(value) {
  const url = new URL(String(value || ''))
  if (url.protocol !== 'https:' || url.username || url.password
    || url.pathname !== '/' || url.search || url.hash) {
    throw new Error('Invalid FlyPay return origin')
  }
  return url.origin
}

export function resolveFlyPayReturnRouting(value = defaultRouting) {
  const config = typeof value === 'string' ? JSON.parse(value) : value
  if (!config || !Array.isArray(config.bridges)) throw new Error('Invalid FlyPay return routing')
  const callbackOrigin = approvedOrigin(config.callbackOrigin)
  const ids = new Set()
  const sources = new Set()
  const bridges = config.bridges.map(rule => {
    const id = String(rule?.id || '')
    if (!/^[a-z0-9][a-z0-9_-]{0,63}$/.test(id) || ids.has(id)) {
      throw new Error('Invalid or duplicate FlyPay return route')
    }
    const sourceOrigin = approvedOrigin(rule.sourceOrigin)
    const targetOrigin = approvedOrigin(rule.targetOrigin)
    if (sources.has(sourceOrigin)) throw new Error('Duplicate FlyPay checkout origin')
    ids.add(id)
    sources.add(sourceOrigin)
    return { id, sourceOrigin, targetOrigin }
  })
  return { callbackOrigin, bridges }
}
